import axios from 'axios';

import { backendUrl } from './globalSettings';
import { getAccessToken } from './AuthContext';

const axiosInstance = axios.create({ baseURL: backendUrl });
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = await getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);
export default axiosInstance;
